import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/** Keep bookmarks, shared chapters and sign-in returns on the renamed route. */
export default function LegacyStudioRedirect() {
  const { search, hash, state } = useLocation();
  return <Navigate to={{ pathname: '/create/gambit', search, hash }} state={state} replace />;
}
